import { Button } from './button';
import { ComponentsDesignTokens } from '@primeuix/themes/types';
import { FloatLabel } from './floatlabel';
import { Table } from './table';
import { Panel } from './panel';
import { Paginator } from './paginator';
import { Dialog } from './dialog';
import { Tabs } from './tabs';
import { Divider } from './divider';
import { Card } from './card';
import { FileUpload } from './fileupload';
import { Breadcrumb } from './breadcrumb';
import { Menubar } from './menubar';
import { ToggleButton } from './togglebutton';

export const Components: ComponentsDesignTokens = {
  button: Button,
  floatlabel: FloatLabel,
  datatable: Table,
  panel: Panel,
  paginator: Paginator,
  dialog: Dialog,
  tabs: Tabs,
  divider: Divider,
  card: Card,
  fileupload: FileUpload,
  breadcrumb: Breadcrumb,
  menubar: Menubar,
  togglebutton: ToggleButton
};
